<template lang="html">
  <div class="yuesao-list">
    <ul>
      <li class="yuesao-list-item" v-for="(item, index) in list">
        <a :href="`/v/user/${item.uid}`" @click="clickTrack(index, item)">
          <i v-if="item.isExclusive == 1"></i>
          <img :src="item.headImage | avatarAdvi(120, 120)" />
          <p class="name">{{ item.name || item.workerName }}</p>
          <p class="store">{{ item.storeName }}</p>
          <button>咨询</button>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  PAGE_ID: '288987',
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  methods: {
    clickTrack(index, item) {
      const uid = this.$$cookie('uid') || ''
      this.trackClick(
        200020,
        { workerId: item.uid, workerName: item.name, fuid: uid },
        `workerId: ${item.uid}, workerName: ${item.name}, fuid: ${uid}`,
        121011908,
        `${index + 1}`
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.yuesao-list {
  border-radius: rem(16px);
  overflow: hidden;
  margin-top: rem(24px);
}
.yuesao-list ul {
  display: flex;
  align-items: center;
  text-align: center;

  overflow-x: auto;
  position: static;
  flex-flow: row nowrap;
  top: 0;

  &::-webkit-scrollbar {
    display: none;
  }
  li {
    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      padding-right: 0;
    }
    a {
      width: rem(194px);

      margin: 0;
      padding: 0 rem(20px);

      position: relative;
      > i {
        display: block;
        position: absolute;
        width: rem(60px);
        height: rem(28px);
        top: 0;
        left: 0;
        background: url('~@/assets/images/lab-zs@3x.png') no-repeat center;
        background-size: rem(60px) auto;
      }
      .name {
        padding-top: rem(20px);
        font-size: rem(28px);
        color: #333;
        line-height: rem(34px);
        font-weight: bold;
      }
      .level {
        padding-top: rem(10px);
        font-size: rem(22px);
        color: #999999;
      }
      .store {
        margin-top: rem(8px);
        font-size: rem(22px);
        color: #999999;
        line-height: rem(28px);

        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      button {
        width: rem(96px);
        font-size: rem(24px);
        color: #ff397e;
        letter-spacing: 0;
        line-height: rem(42px);
        background-color: #ffebf2;
        border-radius: rem(21px);
        margin-top: rem(32px);
        font-weight: 500;
      }
    }
  }

  img {
    width: rem(108px);
    height: rem(108px);
    border-radius: 50%;
    object-fit: cover;
  }
  a {
    display: block;
    font-size: 0;
  }
}
</style>
